// extracted by mini-css-extract-plugin
export var modal = "_t4-0";
export var table = "_t4-1";